import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './MainSearchSnippetsContainer';
import { LegislationSnippet } from './legislation/LegislationSnippet';
import { SearchCommentarySnippet } from './commentary/SearchCommentarySnippet';
import { SearchLegalTermSnippet } from './legal-term/SearchLegalTermSnippet';

type Props = PropsFromRedux;

export const RawMainSearchSnippets: FC<Props> = ({
  legislationSnippet,
  legalTermSnippet,
  commentariesSnippet,
  originalQueryKey,
}) => {
  return (
    <div className="main-snippets">
      {!!legislationSnippet && (
        <LegislationSnippet
          originalQueryKey={originalQueryKey}
          legislation={legislationSnippet}
        />
      )}
      {!!legalTermSnippet && (
        <SearchLegalTermSnippet legalTerm={legalTermSnippet} />
      )}
      {!!commentariesSnippet && (
        <SearchCommentarySnippet commentaries={commentariesSnippet} />
      )}
    </div>
  );
};
export const MainSearchSnippets = Connect(RawMainSearchSnippets);
